<template>
  <div class="detail-page">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item
        :to="{ path: `/goodslist?category=${item.id}` }"
        v-for="item in categoryPath"
        :key="item.id"
      >{{item.name}}</el-breadcrumb-item>
      <el-breadcrumb-item
        style="cursor: pointer"
        @click.native="goList"
        v-if="showLabel && categoryPath.length === 0"
      >{{showLabel}}</el-breadcrumb-item>
      <el-breadcrumb-item>{{choseGoods.name}}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="goods-info">
      <div class="img-area">
        <div class="main-img">
          <img
            @contextmenu.prevent
            v-if="imgList.length === 0"
            src="../../assets/no-picture.png"
            alt
          />
          <!-- <img v-else :src="imgList[choseImgIndex]" alt /> -->
          <div
            @contextmenu.prevent
            @mousemove="scanPic"
            @mouseleave="largePic=false"
            v-else
            :style="`background-image: url(${imgList[choseImgIndex]})`"
          ></div>
          <div
            @contextmenu.prevent
            v-show="largePic"
            class="hide"
            :style="`background-image: url(${imgList[choseImgIndex]});background-position:${layerX} ${layerY}`"
          ></div>
        </div>
        <div class="img-box">
          <div class="prev" @click="prevPage">
            <i class="el-icon-arrow-left"></i>
          </div>
          <div
            :class="{img: true, chose: i+imgPage*4 === choseImgIndex}"
            v-for="(url, i) in imgList.slice(imgPage*4, imgPage*4+4)"
            :key="i"
            @click="choseImgIndex = imgPage*4+i"
          >
            <img @contextmenu.prevent :src="url" alt />
          </div>
          <div class="next" @click="nextPage">
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
      </div>
      <div class="info-area">
        <h2 class="title">{{choseGoods.name}}</h2>
        <p class="describe" v-html="choseGoods.intro && choseGoods.intro.split('##').join('<br>')"></p>
        <span @click="scrollDetail">查看更多</span>
        <el-divider style="margin: 10px 0"></el-divider>
        <p>
          <span>货期（天）</span>
          <span>{{choseGoods.deliveryTime}}</span>
        </p>
        <p v-if="choseGoods.specification">
          <span class="radio-span">规格</span>
          <span v-if="!groupNo">{{choseGoods.specification}}</span>
          <el-radio-group
            v-else
            @change="changeSpec('specification', $event)"
            v-model="specification"
            size="small"
          >
            <el-radio
              :disabled="z.disable"
              :label="z.label"
              border
              v-for="z in specificationList"
              :key="z.label"
            >{{z.label}}</el-radio>
          </el-radio-group>
        </p>
        <p v-if="choseGoods.color">
          <span class="radio-span">颜色</span>
          <span v-if="!groupNo">{{choseGoods.color}}</span>
          <el-radio-group v-else @change="changeSpec('color', $event)" v-model="color" size="small">
            <el-radio
              :disabled="z.disable"
              :label="z.label"
              border
              v-for="z in colorList"
              :key="z.label"
            >{{z.label}}</el-radio>
          </el-radio-group>
        </p>
        <p v-if="choseGoods.texture">
          <span class="radio-span">材质</span>
          <span v-if="!groupNo">{{choseGoods.texture}}</span>
          <el-radio-group
            v-else
            @change="changeSpec('texture', $event)"
            v-model="texture"
            size="small"
          >
            <el-radio
              :disabled="z.disable"
              :label="z.label"
              border
              v-for="z in textureList"
              :key="z.label"
            >{{z.label}}</el-radio>
          </el-radio-group>
        </p>
        <p>
          <span class="market-price">价格：
             <span v-if="$store.state.user.username">￥{{choseGoods.marketPrice}}</span>
             <span v-else :style="{'font-size': '12px', 'color': '#999'}">登录后可见</span>
          </span>
          <!-- <span
            v-if="choseGoods.collectivePrice && $store.state.user.info.username"
            class="collect-price"
          >集采价：￥{{choseGoods.collectivePrice}}</span> -->
          <!-- <span
            v-if="$store.state.user.info.userType == 4"
            class="collect-price"
          >集采价：￥{{choseGoods.collectivePrice}}</span>
          <span v-else class="collect-price">优惠价：￥{{choseGoods.preferentialPrice}}</span>-->
        </p>
        <p>
          <span>数量</span>
          <el-input-number v-model="number" :min="1" size="small" style="width: 120px;margin-left:10px;"></el-input-number>
        </p>
        <div class="button-box">
          <button class="common-btn" @click="addCart">加入购物车</button>
          <button class="common-btn" @click="addOrder">立即购买</button>
          <button class="common-btn" @click="attention">关注</button>
          <!-- <button class="common-btn" @click="exportPPT">生成PPT</button> -->
          <!-- <button class="common-btn-primary" @click="exportExcel">导出Excel表格</button> -->
        </div>
      </div>
    </div>
    <div class="detail-area" v-if="$store.state.user.username">
      <div class="detail-l" v-html="choseGoods.leftDetails"></div>
      <div class="detail-r" v-html="choseGoods.rightDetails"></div>
    </div>
    <template v-if="choseGoods.pdfPath">
      <p class="title">辅助材料</p>
      <a :href="choseGoods.pdfPath" target="blank">
        <img src="../../assets/download.png" alt />
      </a>
    </template>
    <!-- <p class="title">一起买更优惠</p> -->
    <div class="group-buy"></div>
    <p class="title" v-show="otherGoods.length > 0">
      <span v-if="otherGoodsType === 0">其他同行的选择</span>
      <span v-if="otherGoodsType === 1">组合商品</span>
      <span v-if="otherGoodsType === 2">商品所属组合</span>
    </p>
    <div class="other">
      <div class="img" v-for="(item,i) in otherGoods" :key="i" :title="item.name">
        <img
          @contextmenu.prevent
          v-if="item.defaultImage"
          :src="item.defaultImage"
          @click="goDetail(item)"
        />
        <img @contextmenu.prevent v-else src="../../assets/no-picture.png" @click="goDetail(item)" />
        <p>
          {{item.name}}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import {
  goodsList,
  commodityGroup,
  cartAdd,
  recommend,
  groupsById,
  exportExcel,
  exportPPT,
  myAttentionAdd
} from "@/js/api";
export default {
  name: "detail",
  data() {
    return {
      showLabel: this.$route.query.label || "",
      categoryPath: [],

      goodsID: this.$route.query.id,
      groupNo: this.$route.query.groupNo,
      largePic: false,
      layerX: 0,
      layerY: 0,
      choseImgIndex: 0,
      imgPage: 0,
      choseGoods: {},
      imgList: [],
      groupGoods: [],
      otherGoodsType: 0, // 0：推荐商品 1：下属组合商品 2：属于哪个组合商品
      otherGoods: [],
      number: 1,
      specification: "", // 规格
      color: "", // 颜色
      texture: "", // 材质
      specificationList: [], // 规格
      colorList: [], // 颜色
      textureList: [] // 材质
    };
  },
  mounted() {
    this.getDetail();
    if (this.$route.query.category) {
      this.getCategoryPath();
    }
  },
  watch: {
    "$store.state.category.tree": function() {
      this.getCategoryPath();
    },
    $route: function() {
      this.getDetail();
    }
  },
  methods: {
    // 获取标签路径
    getCategoryPath() {
      const category = this.$route.query.category;
      if (!category) return;
      const tree = this.$store.state.category.tree;
      const data = this.searchData(tree, category);
      this.categoryPath = data;
    },
    searchData(treeList, val) {
      for (let i = 0; i < treeList.length; i++) {
        if (treeList[i].id == val) return [treeList[i]];
        else if (treeList[i].children) {
          const res = this.searchData(treeList[i].children, val);
          if (res.length > 0) return [treeList[i]].concat(res);
        }
      }
      return [];
    },
    // 点击面包屑返回
    goList() {
      const query = this.$route.query;
      let search = "";
      if (query.specialId) {
        search = `specialId=${query.specialId}&label=${query.label}`;
      } else if (query.brandId) {
        search = `brandId=${query.brandId}&label=${query.label}`;
      }
      this.$router.push(`goodsList?${search}`);
    },

    scanPic(e) {
      this.largePic = true;
      let posX = (e.layerX - 100) / 3;
      if (posX < 0) posX = 0;
      if (posX > 100) posX = 100;
      this.layerX = posX + "%";
      let posY = (e.layerY - 100) / 3;
      if (posY < 0) posY = 0;
      if (posY > 100) posY = 100;
      this.layerY = posY + "%";
    },
    prevPage() {
      if (this.imgPage > 0) this.imgPage -= 1;
    },
    nextPage() {
      if (this.imgPage + 1 < this.imgList.length / 4) this.imgPage += 1;
    },
    scrollDetail() {
      if (!this.$store.state.user.info || !this.$store.state.user.info.id)
        return this.$message.warning("请登录后查看！");
      window.scrollTo(0, 792);
    },
    goDetail: function(item) {
      if (item && item.id) {
        this.$router.push(`goodsdetail?id=${item.id}&groupNo=${item.groupNo}`);
        location.reload();
      }
    },
    // 改变规格等参数
    changeSpec(key, val) {
      console.warn(key, val);
      this.specificationList.map(z => {
        z.disable = true;
      });
      this.colorList.map(z => {
        z.disable = true;
      });
      this.textureList.map(z => {
        z.disable = true;
      });
      this.groupGoods.map(z => {
        if (z[key] === val) {
          // 设置可选
          if (key === "specification") {
            this.colorList.map(x => {
              if (x.label === z.color) x.disable = false;
            });
            this.textureList.map(x => {
              if (x.label === z.texture) x.disable = false;
            });
            this.specificationList.map(z => {
              z.disable = false;
            });
          } else if (key === "color") {
            this.specificationList.map(x => {
              if (x.label === z.specification) x.disable = false;
            });
            this.textureList.map(x => {
              if (x.label === z.texture) x.disable = false;
            });
            this.colorList.map(z => {
              z.disable = false;
            });
          } else if (key === "texture") {
            this.specificationList.map(x => {
              if (x.label === z.specification) x.disable = false;
            });
            this.colorList.map(x => {
              if (x.label === z.color) x.disable = false;
            });
            this.textureList.map(z => {
              z.disable = false;
            });
          }
        }
      });
      // 清除不可选的选中
      this.specificationList.map(z => {
        if (z.label === this.specification) {
          if (z.disable) this.specification = "";
          return;
        }
      });
      this.colorList.map(z => {
        if (z.label === this.color) {
          if (z.disable) this.color = "";
          return;
        }
      });
      this.textureList.map(z => {
        if (z.label === this.texture) {
          if (z.disable) this.texture = "";
          return;
        }
      });
      // 切换商品
      const item = this.groupGoods.filter(z => {
        return (
          z.specification === this.specification &&
          z.color === this.color &&
          z.texture === this.texture
        );
      })[0];
      if (item) this.switchGoods(item);
    },
    // 设置可选选项
    setSpecVisible(data, key) {},
    // 设置选项列表
    setSpecList(data) {
      const specificationList = []; // 规格
      const colorList = []; // 颜色
      const textureList = []; // 材质
      data.map(z => {
        if (!specificationList.map(z => z.label).includes(z.specification))
          specificationList.push({
            label: z.specification,
            disable: false
          });
        if (!colorList.map(z => z.label).includes(z.color))
          colorList.push({
            label: z.color,
            disable: false
          });
        if (!textureList.map(z => z.label).includes(z.texture))
          textureList.push({
            label: z.texture,
            disable: false
          });
        this.specificationList = specificationList;
        this.colorList = colorList;
        this.textureList = textureList;
      });
    },
    getDetail() {
      const query = this.$route.query;
      commodityGroup(query).then(res => {
        if (res.code == 0 || res.code == 1) {
          this.groupGoods = res.result || [];
          this.setSpecList(this.groupGoods);
          const item = this.groupGoods.filter(z => z.id == query.id)[0];
          if (item) this.switchGoods(item);
        }
      });
    },
    // 切换商品（分组时切换显示）
    switchGoods(item) {
      this.choseGoods = item;
      this.choseImgIndex = 0;
      this.imgPage = 0;
      this.imgList = item.images ? item.images.split(",") : [];
      if (item.defaultImage) this.imgList.unshift(item.defaultImage);
      // 设置对应属性
      this.specification = item.specification;
      this.color = item.color;
      this.texture = item.texture;
      // type： 0 isGroup：0 普通商品 otherGoodsType 0
      // type： 1 isGroup：0 组合商品 otherGoodsType 1
      // type： 0 isGroup：1 组合单个商品 otherGoodsType 2
      if (item.type == 1) {
        this.otherGoodsType = 1;
      } else if (item.type == 0 && item.isGroup == 1) {
        this.otherGoodsType = 2;
      } else if (item.type == 0 && item.isGroup == 0) {
        this.otherGoodsType = 0;
        recommend({
          id: this.goodsID
        }).then(res => {
          if (res.code == 0) {
            this.otherGoods = res.result || [];
          }
        });
      }
      if (item.groups) {
        this.otherGoods = item.groups;
      }
    },
    // 添加购物车
    addCart() {
      const item = this.choseGoods;
      if (!this.$store.state.user.info.id)
        return this.$message.error("请先登录！");
      cartAdd({
        commodityId: item.id,
        userId: this.$store.state.user.info.id,
        quantity: this.number
      }).then(res => {
        if (res.code == 1) {
          this.$message.success(res.message);
        } else if (res.code == 2) {
          // 不能单独购买
          this.$message.warning("该产品需以整套方案购买");
          groupsById({ id: item.id }).then(res => {
            const arr = res.result;
            if (arr.length > 1) {
              this.$router.push(`goodsList?groupId=${item.id}`);
            } else if (arr.length == 1) {
              const data = arr[0];
              this.$router.push(
                `goodsdetail?id=${data.id}&groupNo=${data.groupNo}`
              );
            }
          });
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 立即购买
    addOrder() {
      if (!this.$store.state.user.info.id)
        return this.$message.error("请先登录！");
      if (this.choseGoods.isGroup == 1) {
        this.addCart();
      } else {
        // 下单页面
        this.$router.push(
          "/order/create?id=" + this.choseGoods.id + "&number=" + this.number
        );
      }
    },
    attention() {
      const item = this.choseGoods;
      if (!this.$store.state.user.info.id)
        return this.$message.error("请先登录！");
      myAttentionAdd({
        id: item.id
      }).then(res => {
        if (res.code == 200) {
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    exportExcel() {
      exportExcel({
        ids: this.choseGoods.id,
        userId: this.$store.state.user.info.id
      });
    },
    exportPPT() {
      exportPPT({
        ids: this.choseGoods.id,
        userId: this.$store.state.user.info.id
      });
    }
  }
};
</script>

<style scoped>
.info-area >>> .el-radio-group {
  width: calc(100% - 40px);
}
.info-area >>> .el-radio {
  margin: 10px;
}
</style>
<style lang="less" scoped>
.detail-page {
  font-size: 16px;
  padding: 20px 60px;
  width: 1200px;
  margin: auto;
  .goods-info {
    display: flex;
    margin-top: 16px;
  }
  .img-area {
    width: 500px;
    .main-img {
      width: 100%;
      height: 500px;
      text-align: center;
      border: solid 1px #cccccc;
      display: flex;
      align-items: center;
      position: relative;
      > div {
        width: 500px;
        height: 500px;
        background-position: center;
        background-size: 100% auto;
        background-repeat: no-repeat;
        cursor: all-scroll;
      }
      > div.hide {
        position: absolute;
        left: 520px;
        z-index: 11;
        background-size: 200% auto;
      }
      > img {
        max-width: 500px;
        max-height: 500px;
        width: 100%;
        // height: 100%;
      }
    }
    .img-box {
      margin-top: 10px;
      height: 100px;
      display: flex;
      align-items: center;
      position: relative;
      padding: 0 20px;
      .prev,
      .next {
        position: absolute;
        display: flex;
        width: 20px;
        height: 100px;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        &:hover {
          background: rgba(0, 0, 0, 0.2);
        }
      }
      .prev {
        left: 0;
      }
      .next {
        right: 0;
      }
      .img {
        margin-left: 10px;
        &:last-child {
          margin-right: 10px;
        }
        position: relative;
        display: inline-block;
        width: 100px;
        height: 100px;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        border: solid 1px #cccccc;
        &.chose::after {
          content: "";
          display: block;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 1;
          background: rgba(0, 0, 0, 0.2);
        }
        img {
          position: absolute;
          top: 0;
          bottom: 0;
          right: 0;
          left: 0;
          margin: auto;
          max-width: 100px;
          max-height: 100px;
        }
      }
    }
  }
  .info-area {
    margin-left: 40px;
    flex: 1;
    .title {
      font-weight: bold;
      font-size: 24px;
    }
    p {
      margin-top: 12px;
    }
    .describe {
      // 240
      min-height: 120px;
      position: relative;
      line-height: 1.5;
      & + span {
        float: right;
        // position: absolute;
        right: 0;
        bottom: -20px;
        cursor: pointer;
        text-decoration-line: underline;
      }
    }
    .radio-span {
      vertical-align: top;
      line-height: 52px;
    }
    .market-price {
      font-weight: bold;
      font-size: 20px;
      color: rgb(197,88,47);
    }
    .collect-price {
      margin-left: 20px;
      font-weight: bold;
      font-size: 20px;
      color: #ffa626;
    }
    .button-box {
      margin-top: 20px;
      button {
        margin-right: 20px;
        width: 120px;
        &:first-child:hover{color: rgb(131, 197, 136);background-color: #fff;border-color: #333;}
        &:nth-child(3):hover{color: #fff;background-color: #333;border-color: #333;}
      }
    }
  }
  .detail-area {
    margin: 40px 0px;
    padding: 20px;
    min-height: 120px;
    // min-height: 240px;
    background: #eee;
    display: flex;
    line-height: 1.5;
    .detail-l {
      margin-right: 100px;
      flex: 2;
    }

    .detail-r {
      flex: 1;
    }
  }
  .other {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .img {
      margin-right: 20px;
      width: 180px;
      height: 180px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      img {
        max-width: 100%;
        max-height: 100%;
      }
      position: relative;
      p {
        position: absolute;
        width: 100%;
        bottom: 0;
        background: rgba(0, 0, 0, 0.2);
        color: #fff;
        padding: 4px 8px;
        span {
          float: right;
        }
      }
    }
  }
  > .title {
    margin: 20px 0;
    font-weight: bold;
    font-size: 24px;
  }
}
</style>
